var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import {useEffect, useState} from "react";
import {getBookingCallSubscriptions} from "../../../context/subscription";
import {SubscriptionKind} from "../../../context/types";
import {notification} from "antd";
const useSubscriptions = (auth, expert) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [total, setTotal] = useState(null);
  const [callLengthList, setCallLengthList] = useState([]);
  useEffect(() => {
    if (!(auth == null ? void 0 : auth.token)) {
      setSubscriptions([]);
      setCallLengthList([]);
      return;
    }
    getBookingCallSubscriptions(expert.id).then((response) => {
      var _a, _b, _c;
      const isExpertPayRated = ((_a = expert.profile) == null ? void 0 : _a.pay_rate) && ((_c = (_b = expert.profile) == null ? void 0 : _b.brand) == null ? void 0 : _c.experts_can_set_rates);
      const callsLength = [];
      const subscriptions2 = response.subscriptions.map((subscription) => {
        if (!callsLength.includes(subscription.call_length)) {
          callsLength.push(subscription.call_length);
        }
        let price = 0;
        if ([SubscriptionKind.single, SubscriptionKind.overage].includes(subscription.kind)) {
          price = subscription.price_per_unit || 0;
          if (subscription.stripe_plan && isExpertPayRated) {
            price = expert.profile.pay_rate;
          }
        } else if (subscription.kind === SubscriptionKind.monthly) {
          price = subscription.price_per_month || 0;
        }
        return __spreadProps(__spreadValues({}, subscription), {price});
      }).sort((a, b) => a.price - b.price);
      setSubscriptions(subscriptions2);
      setTotal(response.total);
      setCallLengthList(callsLength.sort((a, b) => a - b));
    }).catch((error) => {
      notification.error({message: "Error", description: error.message || "Oops! Something went wrong!"});
    });
  }, [auth == null ? void 0 : auth.token, expert.id]);
  return {subscriptions, callLengthList, total};
};
export default useSubscriptions;
